/*eslint id-length: ['error', { exceptions: ['x'] }]*/
angular.module('study.dashboard')
    .component('queriesStatusReport', {
        templateUrl: 'modules/dashboard/components/queries-status-report/template.html',
        controller: [
            'CrdConfigurationService',
            '$window',
            'ShareCrfSDK',
            'gettextCatalog',
            'queryStatusFilter',
            'ShareCrfApiErrorCodes',
            'numberFilter',
            '$q',
            'DashboardUtils',
            function (
                CrdConfigurationService,
                $window,
                ShareCrfSDK,
                gettextCatalog,
                queryStatusFilter,
                ShareCrfApiErrorCodes,
                numberFilter,
                $q,
                DashboardUtils
            ) {
                var vm = this;

                var c3 = $window.c3;

                var charts = {};
                var chartsData = [];

                var labelSingular = CrdConfigurationService.getLabelSingular();
                var labelPlural = CrdConfigurationService.getLabelPlural();
                vm.loading = true;
                vm.error = false;

                vm.$onInit = function () {
                    createCharts();

                    loadData();
                };

                function loadData() {
                    vm.loading = true;
                    vm.error = false;

                    return getChartsData().then(function(data) {
                        // Se guarda la referencia para estar disponible cuando se requiera
                        chartsData = data;

                        // cálculo de la altura de los gráficos: como todos tienen el mismo número de filas, la altura
                        // va a ser la misma
                        // redimensiona la altura del gráfico en función del número de filas
                        var rowHeight = 36; // px per row
                        var offsetLegend = 94;
                        var minHeight = rowHeight + offsetLegend; // at least one row height

                        var chartHeight = Math.max(minHeight, data.length * rowHeight + offsetLegend);

                        angular.forEach(charts, function(chart) {
                            chart.resize({ height: chartHeight });
                        });

                        charts.rate.load({
                            json: data,
                            keys: {
                                x: 'site.code',
                                value: ['rate'],
                            },
                        });
                        addAverageLine(charts.rate, rateAvg(data, 'total'));

                        charts.rateOpen.load({
                            json: data,
                            keys: {
                                x: 'site.code',
                                value: [
                                    'detailStatus.rateNew',
                                    'detailStatus.rateUpdated',
                                    'detailStatus.rateResolutionProposed',
                                    'dummy',
                                ],
                            },
                        });
                        addAverageLine(charts.rateOpen, rateAvg(data, 'status.open'));

                        charts.rateClosed.load({
                            json: data,
                            keys: {
                                x: 'site.code',
                                value: ['status.rateClosed'],
                            },
                        });
                        addAverageLine(charts.rateClosed, rateAvg(data, 'status.closed'));

                        charts.rateType.load({
                            json: data,
                            keys: {
                                x: 'site.code',
                                value: [
                                    'type.rateManual',
                                    'type.rateAutomatic',
                                    'dummy',
                                ],
                            },
                        });
                        addAverageLine(charts.rateType, rateAvg(data, 'total'));
                    }).catch(function (error) {
                        vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);

                        throw error;
                    }).finally(function () {
                        vm.loading = false;
                    });
                }

                function createCharts() {
                    var commonConfig = {
                        data: {
                            type: 'bar',
                            json: [],
                            labels: {
                                format: function(value) {
                                    return DashboardUtils.format.decimals(value);
                                },
                            },
                            empty: {
                                label: {
                                    text: gettextCatalog.getString('No hay datos'),
                                },
                            },
                            order: null,
                        },
                        axis: {
                            rotated: true,
                            x: {
                                type: 'category',
                            },
                        },
                        bar: {
                            width: 20,
                        },
                    };

                    var rateConfig = angular.copy(commonConfig);
                    rateConfig.bindto = '#rate-by-site';
                    rateConfig.data.names = {
                        rate: gettextCatalog.getString('Queries/{{entitylabel}}', {
                            entitylabel: labelSingular,
                        }),
                    };
                    rateConfig.data.colors = {
                        rate: '#475b72',
                    };
                    rateConfig.tooltip = {
                        contents: function(data) {
                            var row = chartsData[data[0].index];

                            return DashboardUtils.tooltip({
                                header: '[' + row.site.code + '] ' + row.site.name,
                                rows: [
                                    {
                                        key: 'records',
                                        label: labelPlural,
                                        value: row.records,
                                    },
                                    {
                                        key: 'queries',
                                        label: gettextCatalog.getString('Queries'),
                                        value: row.total,
                                    },
                                    {
                                        key: 'rate',
                                        label: gettextCatalog.getString('Ratio'),
                                        value: row.rate,
                                        format: 'decimals',
                                        color: '#475b72',
                                    },
                                ],
                            });
                        },
                    }
                    charts.rate = c3.generate(rateConfig);

                    var rateOpenConfig = angular.copy(commonConfig);
                    rateOpenConfig.bindto = '#rate-open-by-site';
                    rateOpenConfig.data.names = {
                        'detailStatus.rateNew': queryStatusFilter('new'),
                        'detailStatus.rateUpdated': queryStatusFilter('updated'),
                        'detailStatus.rateResolutionProposed': queryStatusFilter('resolution_proposed'),
                    };
                    rateOpenConfig.data.colors = {
                        'detailStatus.rateNew': 'darkred',
                        'detailStatus.rateUpdated': 'darkorange',
                        'detailStatus.rateResolutionProposed': 'darkgreen',
                        dummy: 'black',
                    }
                    rateOpenConfig.data.groups = [
                        [
                            'detailStatus.rateNew',
                            'detailStatus.rateUpdated',
                            'detailStatus.rateResolutionProposed',
                            'dummy',
                        ],
                    ];
                    rateOpenConfig.data.labels = {
                        format: {
                            dummy: function(value, id, index) {
                                var row = chartsData[index];

                                return DashboardUtils.format.decimals(row.status.rateOpen);
                            },
                        },
                    },
                    rateOpenConfig.legend = {
                        hide: ['dummy'],
                    };
                    rateOpenConfig.tooltip = {
                        contents: function(data) {
                            var row = chartsData[data[0].index];

                            return DashboardUtils.tooltip({
                                header: '[' + row.site.code + '] ' + row.site.name,
                                rows: [
                                    {
                                        key: 'rate',
                                        label: gettextCatalog.getString('Ratio de queries abiertas'),
                                        value: row.status.rateOpen,
                                        format: 'decimals',
                                    },
                                    {
                                        key: 'rateNew',
                                        label: gettextCatalog.getString('Ratio {{state}}', {
                                            state: queryStatusFilter('new'),
                                        }),
                                        value: row.detailStatus.rateNew,
                                        format: 'decimals',
                                        color: 'darkred',
                                    },
                                    {
                                        key: 'rateUpdated',
                                        label: gettextCatalog.getString('Ratio {{state}}', {
                                            state: queryStatusFilter('updated'),
                                        }),
                                        value: row.detailStatus.rateUpdated,
                                        format: 'decimals',
                                        color: 'darkorange',
                                    },
                                    {
                                        key: 'rateResolutionProposed',
                                        label: gettextCatalog.getString('Ratio {{state}}', {
                                            state: queryStatusFilter('resolution_proposed'),
                                        }),
                                        value: row.detailStatus.rateResolutionProposed,
                                        format: 'decimals',
                                        color: 'darkgreen',
                                    },
                                    {
                                        key: 'records',
                                        label: labelPlural,
                                        value: row.records,
                                    },
                                    {
                                        key: 'open',
                                        label: gettextCatalog.getString('Queries abiertas'),
                                        value: row.status.open,
                                    },
                                    {
                                        key: 'new',
                                        label: queryStatusFilter('new'),
                                        value: row.detailStatus.new || 0,
                                    },
                                    {
                                        key: 'updated',
                                        label: queryStatusFilter('updated'),
                                        value: row.detailStatus.updated || 0,
                                    },
                                    {
                                        key: 'resolutionProposed',
                                        label: queryStatusFilter('resolution_proposed'),
                                        value: row.detailStatus.resolution_proposed || 0,
                                    },
                                ],
                            });
                        },
                    }
                    charts.rateOpen = c3.generate(rateOpenConfig);

                    var rateClosedConfig = angular.copy(commonConfig);
                    rateClosedConfig.bindto = '#rate-closed-by-site';
                    rateClosedConfig.data.names = {
                        'status.rateClosed': gettextCatalog.getString('Queries/{{entitylabel}}', {
                            entitylabel: labelSingular,
                        }),
                    };
                    rateClosedConfig.data.colors = {
                        'status.rateClosed': '#455b73',
                    };
                    rateClosedConfig.tooltip = {
                        contents: function(data) {
                            var row = chartsData[data[0].index];

                            return DashboardUtils.tooltip({
                                header: '[' + row.site.code + '] ' + row.site.name,
                                rows: [
                                    {
                                        key: 'records',
                                        label: labelPlural,
                                        value: row.records,
                                    },
                                    {
                                        key: 'queries',
                                        label: gettextCatalog.getString('Queries cerradas'),
                                        value: row.status.closed,
                                    },
                                    {
                                        key: 'rate',
                                        label: gettextCatalog.getString('Ratio'),
                                        value: row.status.rateClosed,
                                        format: 'decimals',
                                        color: '#475b72',
                                    },
                                ],
                            });
                        },
                    };

                    charts.rateClosed = c3.generate(rateClosedConfig);

                    var rateTypeConfig = angular.copy(commonConfig);
                    rateTypeConfig.bindto = '#rate-type-by-site';
                    rateTypeConfig.data.names = {
                        'type.rateManual': gettextCatalog.getString('Manuales', {}, 'no automáticas'),
                        'type.rateAutomatic': gettextCatalog.getString('Automáticas'),
                    };
                    rateTypeConfig.data.colors = {
                        'type.rateManual': '#455b73',
                        'type.rateAutomatic': '#e67259',
                        dummy: 'black',
                    };
                    rateTypeConfig.data.groups = [
                        ['type.rateManual', 'type.rateAutomatic', 'dummy'],
                    ];
                    rateTypeConfig.data.labels = {
                        format: {
                            dummy: function(value, id, index) {
                                var row = chartsData[index];

                                return DashboardUtils.format.decimals(row.rate);
                            },
                        },
                    },
                    rateTypeConfig.legend = {
                        hide: ['dummy'],
                    };

                    rateTypeConfig.tooltip = {
                        contents: function(data) {
                            var row = chartsData[data[0].index];

                            return DashboardUtils.tooltip({
                                header: '[' + row.site.code + '] ' + row.site.name,
                                rows: [
                                    {
                                        key: 'rate',
                                        label: gettextCatalog.getString('Ratio de queries'),
                                        value: row.rate,
                                        format: 'decimals',
                                    },
                                    {
                                        key: 'rateManual',
                                        label: gettextCatalog.getString('Ratio de queries manuales'),
                                        value: row.type.rateManual,
                                        format: 'decimals',
                                        color: '#455b73',
                                    },
                                    {
                                        key: 'rateAutomatic',
                                        label: gettextCatalog.getString('Ratio de queries automáticas'),
                                        value: row.type.rateAutomatic,
                                        format: 'decimals',
                                        color: '#e67259',
                                    },
                                    {
                                        key: 'records',
                                        label: labelPlural,
                                        value: row.records,
                                    },
                                    {
                                        key: 'total',
                                        label: gettextCatalog.getString('Número de queries totales'),
                                        value: row.total,
                                    },
                                    {
                                        key: 'manual',
                                        label: gettextCatalog.getString('Queries manuales'),
                                        value: row.type.manual,
                                    },
                                    {
                                        key: 'automatic',
                                        label: gettextCatalog.getString('Queries automáticas'),
                                        value: row.type.automatic,
                                    },
                                ],
                            });
                        },
                    };

                    charts.rateType = c3.generate(rateTypeConfig);
                }

                function getChartsData() {
                    return $q.resolve()
                        .then(ShareCrfSDK.dashboard.queriesStatusDetail)
                        .then(function(data) {
                            return data.map(function(row) {
                                row.dummy = 0; // Para asociar el label de la barra a este dato
                                row.rate = rate(row, 'total');
                                row.detailStatus.rateNew = rate(row, 'detailStatus.new');
                                row.detailStatus.rateUpdated = rate(row, 'detailStatus.updated');
                                row.detailStatus.rateResolutionProposed = rate(row, 'detailStatus.resolution_proposed');
                                row.status.rateOpen = rate(row, 'status.open');
                                row.status.rateClosed = rate(row, 'status.closed');
                                row.type.rateManual = rate(row, 'type.manual');
                                row.type.rateAutomatic = rate(row, 'type.automatic');

                                return row;
                            });
                        });
                }

                function rate(row, key) {
                    return row.records === 0 ? 0 : $window._.get(row, key, 0) / row.records;
                }

                function rateAvg(data, key) {
                    if (data.length === 0) {
                        return 0;
                    }

                    var queries = 0;
                    var records = 0;

                    angular.forEach(data, function (row) {
                        queries += $window._.get(row, key, 0);
                        records += row.records;
                    });

                    return records > 0 ? queries / records : 0;
                }

                function addAverageLine(chart, value) {
                    chart.ygrids.add({
                        value: value,
                        text: gettextCatalog.getString('Promedio: {{value}}', {
                            value: DashboardUtils.format.decimals(value),
                        }),
                    });
                }
            },
        ],
    });
